<template>
    <div id="browse-container">
        <input id="fileInput" type="file" accept=".mp3,.wav" ref="fileInput" @change="handleFileChange" hidden>
        <button id="file-icon" class="btn" @click.prevent="$refs.fileInput.click()" title="Browse for sound">
            <i class="fa-solid fa-file-audio fa-lg"></i>
        </button>
        <span id="filename-container" ref="filename">
            <label for="fileInput">{{ selectedFile ? selectedFile.name : 'Select a file...'}}</label>
        </span>
        <Player :source="audio" />
    </div>
</template>


<script>
import Player from './Player.vue';

export default {
    props: ['value'],
    emits: ['input', 'change'],
    components: { Player },
    data() {
        return {
            selectedFile: this.value,
            audio: {
                url: null,
                duration: 0
            }
        }
    },
    mounted() {
        if(this.value) {
            this.setAudio(this.value)
        }
    },
    methods: {
        setAudio(file) {
            this.audio = {
                url: window.URL.createObjectURL(file)
            }

            if (file.name.length > 11) {
                this.$refs.filename.classList.add('scroll')
            } else {
                this.$refs.filename.classList.remove('scroll')
            }
        },
        handleFileChange(e) {
            this.selectedFile = e.target.files[0]
            this.setAudio(this.selectedFile)
            this.$emit('input', e.target.files[0])
        }
    }
}
</script>

<style scoped>
#browse-container {
    display: flex;
    align-items: center;
    background-color: #036;
    color: white;
    border-radius: 0.75rem;
    padding: 0.15rem 0.5rem;
    width: 100%;
}

#browse-container button {
    width: 3rem;
}

#file-icon {
    color: white;
}

#filename-container {
    white-space: nowrap;
    overflow: hidden;
    width: 8rem;
}

#filename-container > label {
    font-size: 0.9rem;
    cursor: pointer;
    margin: auto;
}

#filename-container.scroll > label {
    animation: scrollText 8s linear infinite;
    display: inline-block;
}

@keyframes scrollText {
    0% {
        transform: translateX(0);
    }

    30% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(-80%);
    }
}</style>